// extracted by mini-css-extract-plugin
export var NonVrImage = "styles-module--NonVrImage--3T7b5";
export var NonVrImageContainer = "styles-module--NonVrImageContainer--3a0Md";
export var VrImageContainer = "styles-module--VrImageContainer---wWtB";